import { combineReducers } from 'redux'
import idToken from './idToken'
import loginUser from './loginUser'

export default combineReducers<RootReducer>({
  idToken,
  loginUser,
})
